import { createQueryKeyStore } from '@lukemorales/query-key-factory'
import { useQuery } from '@tanstack/react-query'

import { graphql_call as graphql_admin_call } from '../../schemas/server_admin_query'

import { query_admin_search_users } from './users_graphql.ts'

export const keys = createQueryKeyStore({
  users: {
    search: (filters: SearchParams) => ({
      queryKey: [filters],
    }),
    // all: (variables: VariablesOf<typeof query_list_rewards>) => [variables],
  },
})

export type SearchParams = {
  page: number
  query: string
}

/*
active_at: ISO8601DateTime
  created_at: ISO8601DateTime!
  email: String
  id: ID!
  image: String
  locked: Boolean
  name: String
  roles: [String!]
  seed_money_tx: String
  updated_at: ISO8601DateTime!
  uuid: ID!
  wallet_address: String
  wallet_provider: String
 */
export type User = {
  created_at: string
  active_at: string
  email: string
  id: string
  image: string
  locked: boolean
  name: string
  roles: string[]
  seed_money_tx: string
  updated_at: string
  uuid: string
  wallet_address: string
  wallet_provider: string
}

export type SearchResults = {
  nodes: User[]
  // page: number
  // total_pages: number
  // total_count: number
  // results: User[]
}

export function useAdminUsersSearch(params: SearchParams) {
  return useQuery<SearchResults | null>({
    queryKey: keys.users.search(params).queryKey,
    queryFn: async () => {
      const result = await graphql_admin_call({
        query: query_admin_search_users,
        variables: params,
      })
      if (result.nodes == null) return null
      return { nodes: result.nodes as User[] }
      // return {
      //   page: params.page,
      //   total_count: result.total_count,
      //   total_pages: result.total_pages,
      //   results: result.results as User[]//.map(r => r as User)
      // } as SearchResults
    },
    staleTime: Infinity,
    gcTime: Infinity,
  })
}
